export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  // Haversine formula to calculate distance between two coordinates in km
  const R = 6371; // Radius of the Earth in km
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = 
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  return distance;
};

export const getGoogleMapsUrl = (placeId, lat, lng) => {
  console.log('getGoogleMapsUrl called with:', { placeId, lat, lng });
  
  // Always use coordinates since we don't have real Google Place IDs
  if (lat && lng) {
    const url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
    console.log('Opening with coordinates:', url);
    return url;
  }
  
  console.log('No coordinates, using default Google Maps');
  return 'https://www.google.com/maps';
};